<template>
  <div>
    <el-dialog
      :title="bigSortData.title"
      :visible.sync="bigSortData.show"
      width="400px"
      center
    >
      <el-table
        row-key="id"
        id="sortTable"
        :data="tableData"
        border
        :cell-style="{ padding: '1' }"
      >
        <el-table-column
          align="center"
          prop="name"
          :label="$t('GameCategoryName')"
        ></el-table-column>
        <el-table-column align="center"  :label="$t('Actions')">
          <template slot-scope="scope">
            <el-switch
              v-model="tableData[scope.$index].checked"
              :width="35"
              :inactive-text="tableData[scope.$index].checked ? $t('Display') : $t('Hide')"
              style="margin-right: 5px"
              @change="$forceUpdate()"
            >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSort(2)"
          >{{$t('SaveCurrentDomain')}}</el-button
        >
        <el-button type="primary" @click="confirmSort(1)"
          >{{$t('SaveAllDomains')}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  props: {
    bigSortData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
      gameList: [
        { id: 1, state: 1, name: "哈希竞猜" },
        { id: 2, state: 1, Name: this.$t('common.comFooter.game1') },
        { id: 3, state: 1, name: "棋牌游戏" },
        { id: 4, state: 1,  Name: this.$t('common.comFooter.game5')},
        { id: 5, state: 1, name: "哈希电子" },
        { id: 6, state: 1, name: this.$t('betRecord.tHead2') },
        { id: 7, state: 1, name: "体育竞技" },
        { id: 8, state: 2, name: "德州扑克" },
      ],
    };
  },
  created() {
    if (
      this.bigSortData.rowData.MajorGameOrder &&
      this.bigSortData.rowData.MajorGameOrder != "{}"
    ) {
      let data = JSON.parse(this.bigSortData.rowData.MajorGameOrder);
      this.tableData = data;
      // this.gameList.forEach(item => {
      //     data.forEach(item1 => {
      //         if (item.id == item1.id) {
      //             this.tableData.push(item1)
      //         }
      //     })
      // })
    } else {
      this.tableData = this.gameList;
    }
    this.tableData.forEach((item) => {
      item.checked = item.state == 1 ? true : false;
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.initSort();
    });
  },
  methods: {
    initSort() {
      const el = document.querySelector(
        "#sortTable .el-table__body-wrapper > table > tbody"
      );
      new Sortable(el, {
        onEnd: (evt) => {
          const currRow = this.tableData.splice(evt.oldIndex, 1)[0];
          this.tableData.splice(evt.newIndex, 0, currRow);
          this.idsArr = [];
          this.tableData.forEach((item, index) => {
            this.idsArr.push(item.id);
          });
        },
      });
    },
    confirmSort(type) {
      let arr = this.tableData.map((item) => {
        return {
          id: item.id,
          name: item.name,
          state: item.checked ? 1 : 2,
        };
      });
      this.bigSortData.rowData.MajorGameOrder = JSON.stringify(arr);
      this.bigSortData.rowData.IsBatch = type;
      this.$emit("confirmBigSort", this.bigSortData.rowData);
    },
  },
};
</script>
